import { format } from 'date-fns';
import { useContext, useEffect, useState, useCallback } from "react";
import { ApplicationContext, ProviderContext } from "../../ApplicationState";
import * as ApiService from '../../services/ApiService';
import _ from 'lodash';

export const useBreachThreshold = () => {
  const { userState } = useContext(ApplicationContext);
  const { providerState } = useContext(ProviderContext);

  const [measurementData, setMeasurementData] = useState(null);
  const [row, setRow] = useState(null);
  const [columns, setColumns] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch breach measurement data
  const fetchBreachMeasurement = useCallback(async () => {
    try {
      setLoading(true);
      const data = await ApiService.fetchBreachMeasurement(
        userState.authenticatedUser,
        providerState.providerId
      );
      setMeasurementData(data);

      const processedData = processBreachData(data);
      setColumns(generateColumns(processedData)); // Define your column structure
      setRow(processedData);
    } catch (error) {
      console.error('Error fetching breach measurement:');
    } finally {
      setLoading(false);
    }
  }, [userState.authenticatedUser, providerState.providerId]);

  // Process fetched data
  const processBreachData = (data) => {
    const processedData = _.map(data, (reading) => {
      const {
        readingSnapShot,
        email,
        userFullName,
        createdOn,
        reviewStatuses,
        breachValue,
        id,
        userId,
        measurementTypePart,
        measurementId,
      } = reading;

      if (!_.isEmpty(reviewStatuses)) return { id: 1 };

      const measurement = JSON.parse(readingSnapShot);
      const dateFromString = new Date(createdOn);
      const fullDate = `${format(dateFromString, 'yyyy-MM-dd')} ${format(dateFromString, 'hh:mm a')}`;

      const readingValue = _.map(measurement, (value) => value);

      return {
        id,
        email,
        userFullName,
        createdOn: fullDate,
        vitals: readingValue,
        reviewStatuses,
        userId,
        breachValue,
        longName: measurementTypePart.longName,
        measurementId,
      };
    });

    _.remove(processedData, { id: 1 });
    const orderByDate = _.orderBy(processedData, [v => new Date(v.createdOn)], ['desc']);
    return _.uniqBy(orderByDate, 'measurementId');
  };

  // Define columns (customize as needed)
  const generateColumns = (data) => {
    if (!data || data.length === 0) return [];
    return Object.keys(data[0]).map((key) => ({ field: key, headerName: _.startCase(key) }));
  };

  // Fetch data when providerState changes
  // useEffect(() => {
  //   fetchBreachMeasurement();
  // }, [fetchBreachMeasurement]);

  const updateBreachNote = async (data) => {
    try {
      return await ApiService.updateBreachNote(userState.authenticatedUser, data);
    } catch (error) {
      console.error("Error updating breach note:");
      throw error;
    }
  };

  const deleteRow = (index) => {
    setRow((prevRows) => prevRows.filter((_, i) => i !== index));
  };

  const updateRow = (updatedRow) => {
    setRow((prevRows) =>
      prevRows.map((r) => (r.id === updatedRow.id ? updatedRow : r))
    );
  };

  return {
    row,
    columns,
    loading,
    updateBreachNote,
    measurementData,
    deleteRow,
    updateRow,
    fetchBreachMeasurement
  };
};
